var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgSend = function SvgSend(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.462 3.772c-1.79-.826-3.7.885-3.077 2.754l1.745 5.237a.75.75 0 0 1 0 .474l-1.745 5.237c-.623 1.87 1.288 3.58 3.077 2.754l14.877-6.866c1.162-.536 1.162-2.188 0-2.724L6.462 3.772Zm-1.654 2.28a.75.75 0 0 1 1.026-.918L20.71 12 5.834 18.866a.75.75 0 0 1-1.026-.918L6.54 12.75H15a.75.75 0 0 0 0-1.5H6.54L4.808 6.052Z"
  })));
};

export default SvgSend;